<div [formGroup]="fileConfig" class="source-selector">
  <label class="source-label">Upload source</label>
  <mat-button-toggle-group
    class="icon-on-left"
    formControlName="attachmentUploadSource"
    aria-label="Upload source"
    [hideSingleSelectionIndicator]="true"
  >
    <mat-button-toggle [value]="datasourceOption.value">
      @if (datasourceOption.useMaterialIcon) {
        <mat-icon [fontIcon]="datasourceOption.iconClass" class="material-icons-outlined datasource-icon"></mat-icon>
      } @else {
        <i [class]="datasourceOption.iconClass + ' datasource-icon'"></i>
      }
      {{ datasourceOption.label }}
    </mat-button-toggle>
    <mat-button-toggle value="{{ LocalFileNamespace.name }}">
      <mat-icon fontIcon="file_upload" class="material-icons-outlined"></mat-icon>
      Local files
    </mat-button-toggle>
    <mat-button-toggle value="both">
      @if (datasourceOption.useMaterialIcon) {
        <mat-icon [fontIcon]="datasourceOption.iconClass" class="material-icons-outlined datasource-icon"></mat-icon>
      } @else {
        <i [class]="datasourceOption.iconClass + ' datasource-icon'"></i>
      }
      <mat-icon fontIcon="file_upload" class="material-icons-outlined"></mat-icon>
      Both
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
